import React from 'react';
import {
  ComponentParams,
  ComponentRendering,
  Placeholder,
  useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-nextjs';
export interface BOKFContainerProps {
  rendering: ComponentRendering & { params: ComponentParams };
  params: ComponentParams;
}

type ComponentProps = BOKFContainerProps;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getClassValue = (param: unknown): string => {
  if (!param) return '';
  if (typeof param === 'string') return param;

  const paramObj = param as Record<string, unknown>;
  if (paramObj.Class && typeof paramObj.Class === 'object' && 'value' in paramObj.Class) {
    return typeof paramObj.Class.value === 'string' ? paramObj.Class.value : '';
  }
  if ('value' in paramObj) {
    return typeof paramObj.value === 'string' ? paramObj.value : '';
  }

  return '';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getCombinedStyles = (...styleParams: unknown[]): string => {
  try {
    return styleParams
      .map(getClassValue)
      .filter(Boolean)
      .join(' ')
      .replace(/\[object Object\]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  } catch (error) {
    console.error('Error generating combined styles:', error);
    return '';
  }
};

const getBackgroundStyle = (
  backgroundImage: string | undefined,
  pageState: string
): React.CSSProperties => {
  if (!backgroundImage) return {};

  const mediaUrlRegex = /mediaurl="([^"]+)"/;
  const mediaIdRegex = /mediaid="([^"]+)"/;
  const mediaUrlMatch = mediaUrlRegex.exec(backgroundImage);
  const mediaIdMatch = mediaIdRegex.exec(backgroundImage);

  if (mediaUrlMatch?.[1]) {
    return { backgroundImage: `url('${mediaUrlMatch[1]}')` };
  }

  if (mediaIdMatch?.[1]) {
    const prefix = `${pageState !== 'normal' ? '/sitecore/shell' : ''}/-/media/`;
    const mediaId = mediaIdMatch[1].replace(/-/gi, '');
    return { backgroundImage: `url('${prefix}${mediaId}')` };
  }

  return {};
};

const DefaultContainer = (props: ComponentProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const styles = getCombinedStyles(props.params.GridParameters, props.params.Styles);
  const phKey = `container-${props.params.DynamicPlaceholderId}`;
  const id = props.params.RenderingIdentifier;
  const backgroundStyle = getBackgroundStyle(
    props.params.BackgroundImage,
    sitecoreContext.pageState ?? 'normal'
  );

  return (
    <div className={`bokf-component bokf-container ${styles}`} id={id ? id : undefined}>
      <div className="component-content" style={backgroundStyle}>
        <div className="row">
          <Placeholder name={phKey} rendering={props.rendering} />
        </div>
      </div>
    </div>
  );
};

export const Default = (props: ComponentProps): JSX.Element => {
  const stylesValue = getClassValue(props.params?.Styles);
  const isContainerWrapper = stylesValue.split(' ').includes('bokf-container-inner');

  return isContainerWrapper ? (
    <div className="bokf-container-wrapper">
      <DefaultContainer {...props} />
    </div>
  ) : (
    <DefaultContainer {...props} />
  );
};
